import React, { Component } from 'react'
import { TranslationFunction } from 'react-i18next'

import { Pagination } from '../pagination'
import { PaginationInfo } from './models'

import { identity } from '../../shared'

import './smart-table.scss'

export type Slots = {
  rows: JSX.Element[] | JSX.Element
  headerRow: JSX.Element
  filter?: JSX.Element
}

type Props = {
  id: string
  children: Slots
  allowPaging?: boolean
  pageInfo: PaginationInfo
  translate?: TranslationFunction
  onPageChange(page: number): void
}

export class SmartTable extends Component<Props> {
  render() {
    const { children, pageInfo, onPageChange, id, translate = identity } = this.props

    return (
      <div id={id} data-test="data-table">
        <div data-test="data-table-filter" className="table-filter">
          {children.filter}
        </div>
        <div className="data-table-content">
          <div className="table-scrollbar-wrapper">
            <div className="table-scrollbar" />
          </div>
          <div className="table-wrapper">
            <table className="bp3-html-table bp3-html-table-bordered bp3-html-table-striped">
              <thead>{children.headerRow}</thead>
              <tbody>{children.rows}</tbody>
            </table>
          </div>
        </div>
        <div data-test="data-table-footer" className="table-footer">
          {this.renderPagination && (
            <Pagination translate={translate} pageInfo={pageInfo} onPageChange={onPageChange} />
          )}
        </div>
      </div>
    )
  }

  componentDidMount() {
    // add scroll listener for top and bottom table scrollbars
    const layout = document.getElementById(this.props.id)
    const scrollbarWrapper: HTMLElement | null = layout ? layout.querySelector('.table-scrollbar-wrapper') : null
    const tableWrapper: HTMLElement | null = layout ? layout.querySelector('.table-wrapper') : null
    this.linkWrappersForHorizontalScroll(scrollbarWrapper, tableWrapper)
  }

  componentDidUpdate() {
    // set top scrollbar width dynamically
    const layout = document.getElementById(this.props.id)
    const tableScrollbar: HTMLElement | null = layout ? layout.querySelector('.table-scrollbar') : null
    const table: HTMLElement | null = layout ? layout.querySelector('.bp3-html-table') : null

    if (
      tableScrollbar &&
      table &&
      tableScrollbar.getBoundingClientRect().width !== table.getBoundingClientRect().width
    ) {
      tableScrollbar.style.width = `${table.getBoundingClientRect().width}px`
    }
  }

  private linkWrappersForHorizontalScroll = (topWrapper: HTMLElement | null, bottomWrapper: HTMLElement | null) => {
    if (topWrapper && bottomWrapper) {
      topWrapper.onscroll = () => {
        bottomWrapper.scrollLeft = topWrapper.scrollLeft
      }
      bottomWrapper.onscroll = () => {
        topWrapper.scrollLeft = bottomWrapper.scrollLeft
      }
    }
  }

  private get renderPagination() {
    return Boolean(this.props.allowPaging && this.props.pageInfo.numberOfPages > 1)
  }
}

export default SmartTable



// WEBPACK FOOTER //
// ./src/app/shared/smart-table/smart-table.component.tsx